import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { IoPlayOutline } from 'react-icons/io5'
import { Button } from 'src/Common/ui/button'
import { Checkbox } from 'src/Common/ui/checkbox'
import Input from 'src/Common/ui/input'
import SelectInput from 'src/Common/ui/selectInput'
import Textarea from 'src/Common/ui/textArea'
import { cn, inputValidation } from 'src/lib/utils'
import * as PropTypes from 'prop-types'

const DecisionTreeAnalysis = ({ setformData, decisionArray, setDecisionArray, register, formData, onValueChange, errors, control }) => {
    const { t } = useTranslation()

    const onEstimateCheckboxValueChange = (value, data) => {
        setDecisionArray(decisionArray?.map((mapData, mapIdx) => {
            if (mapData?.id === data?.id) {
                return { ...mapData, isChecked: !mapData?.isChecked }
            } else {
                return mapData
            }
        }))
    }

    // const handleCalculate = () => {
    //     let maxCost = -Infinity
    //     let maxDays = -Infinity
    //     let bestCostAlternative = ''
    //     let bestDaysAlternative = ''

    //     formData?.decisionTreeAnalysis?.alternativesData?.forEach(alternative => {
    //         alternative?.outcomesData?.forEach(outcome => {
    //             if (outcome?.outComesCost > maxCost) {
    //                 maxCost = outcome?.outComesCost
    //                 bestCostAlternative = alternative?.alternativeName
    //             }
    //             if (outcome?.outComesDays > maxDays) {
    //                 maxDays = outcome?.outComesDays
    //                 bestDaysAlternative = alternative?.alternativeName
    //             }
    //         })
    //     })

    //     setformData({
    //         ...formData,
    //         decisionTreeAnalysis: {
    //             ...formData?.decisionTreeAnalysis,
    //             bestCostAlternative,
    //             bestDaysAlternative
    //         }
    //     })
    // }

    const handleCalculate = () => {
        let maxExpectedCost = -Infinity
        let maxExpectedDays = -Infinity
        let bestCostAlternative = ''
        let bestDaysAlternative = ''

        formData?.decisionTreeAnalysis?.alternativesData?.forEach(alternative => {
            let totalExpectedCost = 0
            let totalExpectedDays = 0

            alternative?.outcomesData?.forEach(outcome => {
                const expectedCost = outcome?.outComesProbability * outcome?.outComesCost
                const expectedDays = outcome?.outComesProbability * outcome?.outComesDays

                totalExpectedCost += expectedCost
                totalExpectedDays += expectedDays
            })

            if (totalExpectedCost > maxExpectedCost) {
                maxExpectedCost = totalExpectedCost
                bestCostAlternative = alternative?.alternativeName
            }

            if (totalExpectedDays > maxExpectedDays) {
                maxExpectedDays = totalExpectedDays
                bestDaysAlternative = alternative?.alternativeName
            }
        })

        setformData({
            ...formData,
            decisionTreeAnalysis: {
                ...formData?.decisionTreeAnalysis,
                bestCostAlternative,
                bestDaysAlternative
            }
        })
    }

    return (
        <div>
            <Box display="grid" sx={{}} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                <Box gridColumn="span 7">
                    <p className='text-muted font-bold pb-2'>Decision Type</p>
                    <div className='flex flex-row py-4'>
                        {decisionArray?.map((mapDt, key) =>
                            <div key={key} className='flex mt-auto mb-4 pr-4'>
                                <Checkbox
                                    checked={mapDt?.isChecked}
                                    borderColor={`hsl(var(--${mapDt?.title}))`}
                                    onCheckedChange={(e) => onEstimateCheckboxValueChange(e, mapDt)}
                                    className={mapDt?.isChecked ? 'my-auto border-none' : 'my-auto'}
                                />
                                {mapDt?.title && <label className='grc-label ml-2'>{mapDt?.title}</label>}
                            </div>)}
                    </div>
                </Box>
            </Box>
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 6">
                    <div className='relative' style={{ marginBottom: '2%' }}>
                        <Textarea className={cn('ml-[0px]')} label="Description" rules={{
                            validate: (value) => {
                                return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                            }
                        }} register={register} value={formData?.decisionTreeAnalysis?.decisionDiscription} type="text" placeholder="Enter Description" onValueChange={(el) => onValueChange(el, 'decisionDiscription')} name="decisionDiscription" errors={errors} control={control} required maxLength={250} />
                        <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', formData?.decisionTreeAnalysis?.decisionDiscription?.length > 250 ? '!text-danger' : 'text-muted')}>{formData?.decisionTreeAnalysis?.decisionDiscription?.length || 0}/250</div>
                    </div>
                </Box>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 3">
                    <SelectInput label={t('No of Alternatives')} control={control} errors={errors} required rules={{ required: 'This field is Required' }} name="noOfAlternatives" placeholder="Select" onValueChange={onValueChange} value={formData?.decisionTreeAnalysis?.noOfAlternatives} defaultValue={1} options={[{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }]} />
                </Box>
            </Box>
            {formData?.decisionTreeAnalysis?.alternativesData?.map((mapData, index) => (<div key={index}>
                <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 3">
                        {<Input errors={errors} required rules={{ required: 'This field is Required' }} control={control} name={'alternativeName' + index} label={t(`Alternative ${index + 1} Name`)} register={register} placeholder={t('Enter Alternative 1 Name')} type="text" value={mapData?.alternativeName} onValueChange={(el) => onValueChange(el.target.value, 'alternativeName', index)} />}
                    </Box>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 3">
                        <SelectInput label={t('No of Outcome')} control={control} errors={errors} required rules={{ required: 'This field is Required' }} name={'noOfOutcome' + index} placeholder="Select" onValueChange={(el) => onValueChange(el, 'noOfOutcome', index)} value={mapData?.noOfOutcome} defaultValue={1} options={[{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }]} />
                    </Box>
                </Box>
                {mapData?.outcomesData?.map((chMapData, chIdx) => (<Box key={chIdx} display="grid" sx={{ height: '200px' }} gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 6">
                        <div className='relative' style={{ marginBottom: '2%' }}>
                            <Textarea className={cn('ml-[0px]')} label={`Outcome ${chIdx + 1} Descriptions`} rules={{
                                validate: (value) => {
                                    return inputValidation(value, value?.length < 251, t('This field is required'), t('Characters should be less than 250'))
                                }
                            }} register={register} value={chMapData?.outComesDiscription} type="text" placeholder={`Enter Outcome ${chIdx + 1} Description`} onValueChange={(el) => onValueChange(el, 'outComesDiscription', index, chIdx)} name={'outComesDiscription' + index + chIdx} errors={errors} control={control} required maxLength={250} />
                            <div className={cn('absolute bottom-[25px] right-[10px] text-muted text-[10px]', chMapData?.outComesDiscription?.length > 250 ? '!text-danger' : 'text-muted')}>{chMapData?.outComesDiscription?.length || 0}/250</div>
                        </div>
                    </Box>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 2">
                        <div className='relative flex flex-col justify-between'>
                            {<Input errors={errors} control={control} name='outComesProbability' label={t('Probability')} register={register} placeholder={t('Enter Probability')} type="number" value={chMapData?.outComesProbability} onValueChange={(el, name) => onValueChange(el.target.value, name, index, chIdx)} rules={{ min: { value: 0, message: t('Probability must be at least 0') }, max: { value: 100, message: t('Probability must not exceed 100') } }} />}
                        </div>
                    </Box>
                    {decisionArray[0]?.isChecked && <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 2">
                        <div className='relative flex flex-col justify-between'>
                            <Input errors={errors} control={control} name='outComesCost' label={t('Cost')} register={register} placeholder={t('Enter cost')} type="number" value={chMapData?.outComesCost} onValueChange={(el, name) => onValueChange(el.target.value, name, index, chIdx)} rules={{ min: { value: 0, message: t('Cost must be at least 0') }, max: { value: 999999999999, message: t('Cost must not exceed 999999999999') } }} />
                        </div>
                    </Box>}
                    {decisionArray[1]?.isChecked && <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} gridColumn="span 2">
                        <div className='relative flex flex-col justify-between'>
                            <Input errors={errors} control={control} name='outComesDays' label={t('Days')} register={register} placeholder={t('Enter Days')} type="number" value={chMapData?.outComesDays} onValueChange={(el, name) => onValueChange(el.target.value, name, index, chIdx)} rules={{ min: { value: 0, message: t('Days must be at least 0') }, max: { value: 9999, message: t('Days must not exceed 9999') } }} />
                        </div>
                    </Box>}
                </Box>))}
            </div>))}
            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={4}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '20px' }} gridColumn={decisionArray?.every(item => item.isChecked) ? 'span 9' : 'span 5'}>
                    {decisionArray?.some((data) => data?.isChecked === true) && <Button
                        component='label'
                        size='small'
                        onClick={handleCalculate}
                    >
                        <span className="flex text-card items-center" style={{ fontWeight: 'bold' }}>
                            <IoPlayOutline color='hsl(var(--card))' className="mr-2" size={15} /> Calculate
                        </span>
                    </Button>}
                    {decisionArray[0]?.isChecked && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <p className='text-primary font-bold pb-2'>Best Cost Decision : </p>
                        <p className='text-muted font-bold break-words'>{formData?.decisionTreeAnalysis?.bestCostAlternative || '-'}</p>
                    </div>}
                    {decisionArray[1]?.isChecked && <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <p className='text-primary font-bold pb-2'>Best Day Decision : </p>
                        <p className='text-muted font-bold break-words'>{formData?.decisionTreeAnalysis?.bestDaysAlternative || '-'}</p>
                    </div>}
                </Box>
            </Box>
        </div>
    )
}

DecisionTreeAnalysis.propTypes = {
    decisionArray: PropTypes.any,
    setDecisionArray: PropTypes.any,
    register: PropTypes.any,
    formData: PropTypes.any,
    onValueChange: PropTypes.any,
    errors: PropTypes.any,
    setformData: PropTypes.any,
    control: PropTypes.any
}

export default DecisionTreeAnalysis
